import { Fragment, useEffect, useState } from "react";
import { Page, Text, View, Image } from "@react-pdf/renderer";
import { stylesSinGraficoXl3 } from "../styles";
import logoTeamworkAzul from "../../../../assets/images/pdfPsicolaboral/logoTeamworkAzul.png";
import {
  IPDFCategoriasEvaluacion,
  IPDFCompetenciasEvaluada,
  IPDFPagePortada,
} from "../../../../interfaces/ISeleccion";
import { formatFirstLetterUpper } from "../../../../functions/kit-mdtw/texts";

const SinGraficoXl3 = (props: IPDFPagePortada) => {
  const { formList } = props;
  const [listRender, setListRender] = useState<any>({
    sintesis: "",
    experienciaRelevante: "",
    conocimientosTecnicos: "",
    fortalezas: "",
    oportunidades: "",
    conclusionInforme: "",
    reclutador: "",
    descripcionEvaluacion: "",
    categoriasEvaluacion: [],
    competenciasEvaluadas: [],
  });

  useEffect(() => {
    if (formList) {
      const { contenido } = formList ?? { contenido: {} };
      const { portada } = formList ?? { portada: {} };
      setListRender((prev: any) => ({ ...prev, ...contenido, ...portada }));
    }
  }, [formList]);

  return (
    <>
      {formList && Object.keys(formList).length > 0 && (
        <Page size="LETTER">
          <View style={stylesSinGraficoXl3.body}>
            <Image
              src={logoTeamworkAzul}
              style={stylesSinGraficoXl3.logoTeamWork}
            />
            <View style={stylesSinGraficoXl3.containerEvaluacion}>
              <View style={stylesSinGraficoXl3.containerEvaluacionGridTitle}>
                <Text style={stylesSinGraficoXl3.containerEvaluacionTitle}>
                  EVALUACIÓN POR COMPETENCIAS
                </Text>
              </View>
              <View style={stylesSinGraficoXl3.containerEvaluacionGridSubtitle}>
                <Text style={stylesSinGraficoXl3.containerEvaluacionSubtitle}>
                  PERFIL DE COMPETENCIAS
                </Text>
                <View
                  style={stylesSinGraficoXl3.containerEvaluacionGridMessage}
                >
                  <Text
                    style={
                      stylesSinGraficoXl3.containerEvaluacionSubtitleMessage
                    }
                  >
                    En el siguiente formato, se utilizan las escalas de
                    competencias para el cargo evaluado el que ayudará a
                    determinar:
                  </Text>
                  <Text
                    style={
                      stylesSinGraficoXl3.containerEvaluacionSubtitleMessage
                    }
                  >
                    - Ausencia o presencia de la competencia.
                  </Text>
                  <Text
                    style={
                      stylesSinGraficoXl3.containerEvaluacionSubtitleMessage
                    }
                  >
                    - Nivel en función de las conductas observadas durante el
                    desarrollo de una entrevista de carácter Conductual.
                  </Text>
                </View>
              </View>
              <View
                style={stylesSinGraficoXl3.containerEvaluacionTableCompetencia}
              >
                <Text
                  style={
                    stylesSinGraficoXl3.containerEvaluacionTableCompetenciaTitle
                  }
                >
                  CATEGORÍAS EVALUACIÓN COMPETENCIAS
                </Text>
              </View>

              {listRender &&
                listRender.categoriasEvaluacion.map(
                  (item: IPDFCategoriasEvaluacion, index: number) => {
                    return (
                      <Fragment key={index}>
                        <View
                          style={
                            stylesSinGraficoXl3.containerEvaluacionTableTrCompetencia
                          }
                        >
                          <View
                            style={
                              stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaTitle
                            }
                          >
                            <Text
                              style={
                                stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaTitleText
                              }
                            >
                              {formatFirstLetterUpper({ texto: item.nombre })}
                            </Text>
                          </View>
                          <View
                            style={
                              stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaDescrition
                            }
                          >
                            <Text
                              style={
                                stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaDescritionText
                              }
                            >
                              {formatFirstLetterUpper({
                                texto: item.descripcion,
                              })}
                            </Text>
                          </View>
                          <View
                            style={
                              stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaPoint
                            }
                          >
                            <Text
                              style={
                                stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaPointText
                              }
                            >
                              {item.valor}
                            </Text>
                          </View>
                        </View>
                      </Fragment>
                    );
                  }
                )}

              <View
                style={
                  stylesSinGraficoXl3.containerEvaluacionTableTrCompetenciaLaboral
                }
              >
                <View
                  style={
                    stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralTitle
                  }
                >
                  <Text
                    style={
                      stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralTitleText
                    }
                  >
                    Competencias laborales
                  </Text>
                </View>
                <View
                  style={
                    stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralNum
                  }
                >
                  <Text
                    style={
                      stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralNumText
                    }
                  >
                    1
                  </Text>
                </View>
                <View
                  style={
                    stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralNum
                  }
                >
                  <Text
                    style={
                      stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralNumText
                    }
                  >
                    2
                  </Text>
                </View>
                <View
                  style={
                    stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralNum
                  }
                >
                  <Text
                    style={
                      stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralNumText
                    }
                  >
                    3
                  </Text>
                </View>
                <View
                  style={
                    stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralNum
                  }
                >
                  <Text
                    style={
                      stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralNumText
                    }
                  >
                    4
                  </Text>
                </View>
                <View
                  style={
                    stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralNum
                  }
                >
                  <Text
                    style={
                      stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralNumText
                    }
                  >
                    5
                  </Text>
                </View>
              </View>

              {/* containerEvaluacionTableTrCompetenciaMessage */}

              {listRender.competenciasEvaluadas &&
                listRender.competenciasEvaluadas.slice(0,9).map(
                  (item: IPDFCompetenciasEvaluada, index: number) => {
                    return (
                      <Fragment key={index}>
                        <View
                          style={
                            index % 2
                              ? stylesSinGraficoXl3.containerEvaluacionTableTrCompetenciaMessage
                              : stylesSinGraficoXl3.containerEvaluacionTableTrCompetenciaMessageWhite
                          }
                        >
                          <View
                            style={
                              stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralMessage
                            }
                          >
                            <Text
                              style={
                                stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralMessageText
                              }
                            >
                              {formatFirstLetterUpper({texto: item.competenciaLaboral})}
                            </Text>
                          </View>
                          {[1, 2, 3, 4, 5].map((i, index: number) => (
                            <View
                              style={
                                stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralOption
                              }
                              key={index}
                            >
                              <Text
                                style={
                                  stylesSinGraficoXl3.containerEvaluacionTableTdCompetenciaLaboralOptionText
                                }
                              >
                                {i == Number(item.valor) ? "X" : " "}
                              </Text>
                            </View>
                          ))}
                        </View>
                      </Fragment>
                    );
                  }
                )}

              <View style={stylesSinGraficoXl3.containerDescripcion}>
                <View style={stylesSinGraficoXl3.containerDescripText}>
                  <Text style={stylesSinGraficoXl3.contentDescripTitle}>
                    DESCRIPCIÓN GENERAL
                  </Text>
                  <Text style={stylesSinGraficoXl3.contentDescripMessage}>
                    {listRender.descripcionEvaluacion || " "}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </Page>
      )}
    </>
  );
};

export default SinGraficoXl3;
